import { render, staticRenderFns } from "./ToggleConfirmModal.vue?vue&type=template&id=4cab0e31"
import script from "./ToggleConfirmModal.vue?vue&type=script&lang=js"
export * from "./ToggleConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports